import { classifyMasterBookSets } from "./methods/classifyMasterBookSets";
import { convertFromRecommendation } from "./methods/convertFromRecommendation";
import { fetchForEachAreas } from "./methods/fetchForEachAreas";
import { sortByAreaDisplayOrder } from "./methods/sortByAreaDisplayOrder";

export default {
  forTicketStoreIndex(masterBookSets) {
    const sortedMasterBookSets = sortByAreaDisplayOrder(masterBookSets);
    const masterBookList = classifyMasterBookSets(sortedMasterBookSets);
    return fetchForEachAreas(masterBookList);
  },
  forRecommendationIndex(masterBookSets, recommendationsMasterBooks) {
    try {
      const masterBookSetList = convertFromRecommendation(
        masterBookSets,
        recommendationsMasterBooks
      );
      return classifyMasterBookSets(masterBookSetList);
    } catch (e) {
      console.log("Error in forRecommendationIndex: ", e);
      throw e;
    }
  },
};
